<template>
    <van-dialog
        v-model="show"
        :show-confirm-button="false"
        :close-on-click-overlay="false"
        width="320">
        <div class="arrive_time_popup">
            <div class="arrive_time_title">请填写预计到达时间</div>
            <div class="arrive_time_tip">请录入预计到达救援地的时间，便于调度及时跟进</div>
            <div class="arrive_time_input_row">
                <span class="arrive_time_label">预计到达时间</span>
                <div class="arrive_time_input_wrap">
                    <van-field
                        v-model="minutes"
                        type="digit"
                        maxlength="4"
                        input-align="center"
                        placeholder="请输入"
                        @input="onInput" />
                </div>
                <span class="arrive_time_unit">分钟</span>
            </div>
            <div class="arrive_time_quick">
                <div
                    v-for="item in quickList"
                    :key="item"
                    :class="['arrive_time_quick_item', { arrive_time_quick_active: minutes == item }]"
                    @click="selectQuick(item)">
                    <span :class="['arrive_time_quick_text', { arrive_time_quick_text_active: minutes == item }]">
                        {{ item }}分钟
                    </span>
                </div>
            </div>
            <div class="arrive_time_footer">
                <div class="arrive_time_btn arrive_time_btn_later" @click="later">
                    <span class="arrive_time_btn_later_text">稍后填写</span>
                </div>
                <div class="arrive_time_btn arrive_time_btn_submit" @click="submit">
                    <span class="arrive_time_btn_submit_text">提交</span>
                </div>
            </div>
        </div>
    </van-dialog>
</template>

<script>
import { Toast } from 'vant';
import { arriveTimeReport } from '@/apis/checkList';
import { shouldRemindArriveTime, getArriveTimeRemindInterval } from '@/utils/arriveTimeReport.js';

export default {
    name: 'arriveTimeReportPopup',
    props: {
        orderInfo: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            show: false,
            minutes: '',
            submitting: false,
            timerId: null,
            reported: false,
            lastOrderId: '',
            quickList: [20, 30, 60, 90, 120]
        };
    },
    watch: {
        orderInfo: {
            immediate: true,
            deep: true,
            handler(info) {
                this.syncRemind(info);
            }
        },
        show(val) {
            if (val || this.reported || this.timerId) {
                return;
            }
            if (!shouldRemindArriveTime(this.orderInfo)) {
                return;
            }
            this.startTimer();
        }
    },
    beforeDestroy() {
        this.clearTimer();
    },
    methods: {
        syncRemind(info) {
            const orderId = info && info.id;
            if (orderId && this.lastOrderId && orderId !== this.lastOrderId) {
                this.reported = false;
                this.minutes = '';
                this.clearTimer();
                this.show = false;
            }
            this.lastOrderId = orderId || '';
            if (this.reported || !shouldRemindArriveTime(info)) {
                this.clearTimer();
                this.show = false;
                return;
            }
            if (this.show || this.timerId) {
                return;
            }
            this.openPopup();
        },
        openPopup() {
            this.show = true;
        },
        onInput(val) {
            this.minutes = String(val == null ? '' : val).replace(/\D/g, '');
        },
        selectQuick(item) {
            this.minutes = String(item);
        },
        later() {
            this.show = false;
        },
        startTimer() {
            this.clearTimer();
            const ms = getArriveTimeRemindInterval(this.orderInfo);
            if (ms <= 0) {
                return;
            }
            this.timerId = setTimeout(() => {
                this.timerId = null;
                if (!shouldRemindArriveTime(this.orderInfo)) {
                    return;
                }
                this.openPopup();
            }, ms);
        },
        clearTimer() {
            if (this.timerId) {
                clearTimeout(this.timerId);
                this.timerId = null;
            }
        },
        submit() {
            if (this.submitting) {
                return;
            }
            const minutes = String(this.minutes || '').trim();
            if (!minutes) {
                Toast('请输入预计到达时间');
                return;
            }
            if (!/^[1-9]\d*$/.test(minutes)) {
                Toast('请输入有效的分钟数');
                return;
            }
            if (!this.orderInfo || !this.orderInfo.id) {
                Toast('订单信息异常');
                return;
            }
            this.submitting = true;
            Toast.loading({
                message: '提交中',
                forbidClick: true,
                duration: 0
            });
            arriveTimeReport({
                id: this.orderInfo.id,
                arrive_time_report: minutes
            }).then((res) => {
                Toast.clear();
                this.submitting = false;
                if (res.data && res.data.code == 1) {
                    this.$set(this.orderInfo, 'arrive_time_report', Number(minutes) * 60);
                    this.reported = true;
                    this.clearTimer();
                    this.show = false;
                    Toast((res.data && res.data.info) || '提交成功');
                    this.$emit('success', minutes);
                    return;
                }
                Toast((res.data && res.data.info) || '提交失败');
            }).catch(() => {
                Toast.clear();
                this.submitting = false;
                Toast('提交失败');
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.arrive_time_popup {
    padding: 22px 20px 20px;
    box-sizing: border-box;
}
.arrive_time_title {
    font-size: 16px;
    font-weight: bold;
    line-height: 22px;
    color: #191818;
    text-align: center;
    margin-bottom: 8px;
}
.arrive_time_tip {
    font-size: 13px;
    line-height: 20px;
    color: #8A8F99;
    text-align: center;
    margin-bottom: 18px;
}
.arrive_time_input_row {
    display: flex;
    align-items: center;
    margin-bottom: 14px;
}
.arrive_time_label {
    font-size: 14px;
    color: #1F2129;
    margin-right: 8px;
    flex-shrink: 0;
}
.arrive_time_input_wrap {
    flex: 1;
    height: 36px;
    border: 1px solid #E4E4E4;
    border-radius: 4px;
    overflow: hidden;
    box-sizing: border-box;
}
.arrive_time_input_wrap ::v-deep .van-field {
    padding: 0 8px;
    height: 36px;
    line-height: 36px;
}
.arrive_time_input_wrap ::v-deep .van-field__control {
    height: 36px;
    line-height: 36px;
    color: #357EFE;
}
.arrive_time_unit {
    font-size: 14px;
    color: #1F2129;
    margin-left: 8px;
    flex-shrink: 0;
}
.arrive_time_quick {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 6px;
}
.arrive_time_quick_item {
    width: calc((100% - 16px) / 3);
    height: 32px;
    border-radius: 4px;
    border: 1px solid #E4E4E4;
    margin-right: 8px;
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
}
.arrive_time_quick_item:nth-child(3n) {
    margin-right: 0;
}
.arrive_time_quick_active {
    border-color: #357EFE;
    background: #EEF4FF;
}
.arrive_time_quick_text {
    font-size: 13px;
    color: #707070;
}
.arrive_time_quick_text_active {
    color: #357EFE;
}
.arrive_time_footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 14px;
}
.arrive_time_btn {
    width: 48%;
    height: 40px;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
}
.arrive_time_btn_later {
    background: #ffffff;
    border: 1px solid #357EFE;
}
.arrive_time_btn_later_text {
    font-size: 15px;
    color: #357EFE;
}
.arrive_time_btn_submit {
    background: linear-gradient(90deg, #357EFE, #5B9BFF);
}
.arrive_time_btn_submit_text {
    font-size: 15px;
    color: #ffffff;
}
</style>
